// extracted by mini-css-extract-plugin
export default {"navbarWrapper":"NavBarWrapper_navbarWrapper__PtCSt"};